// import remarkGfm from 'remark-gfm';
import { Link, Typography } from '@mui/material';
import * as React from 'react';
import ReactMarkdown from 'react-markdown';

interface MuiMarkdownProps {
  children: string;
}

export function MuiMarkdown(props: MuiMarkdownProps) {
  const { children } = props;

  return (
    <ReactMarkdown
      components={{
        strong: ({ children, ...props }) => (
          <Typography
            component={'span'}
            gutterBottom
            variant="body1"
            fontWeight={600}
            {...props}
          >
            {children}
          </Typography>
        ),
        h2: ({ children, ...props }) => (
          <Typography
            gutterBottom
            variant="h4"
            component={'h2'}
            fontWeight={600}
            {...props}
          >
            {children}
          </Typography>
        ),
        h3: ({ children, ...props }) => (
          <Typography
            gutterBottom
            variant="h5"
            component={'h3'}
            fontWeight={600}
            {...props}
          >
            {children}
          </Typography>
        ),
        p: ({ children, ...props }) => (
          <Typography
            variant="body1"
            component={'p'}
            paragraph
            gutterBottom
            {...props}
          >
            {children}
          </Typography>
        ),
        a: ({ children, ...props }) => (
          <Link target="blank" {...props}>
            {children}
          </Link>
        ),
      }}
    >
      {children}
    </ReactMarkdown>
  );
}
